<template>
  <div class="stripe-tab">
    <img
      class="back"
      src="@/assets/images/icons/arrow_left_dark.svg"
      alt="back"
      v-if="savedPaymentMethods.length"
      @click="setCurrentPaymentTab(PAYMENT_METHOD.STRIPE_SAVED_CARD)"
    />
    <div id="payment-element"></div>
    <!-- <div
      class="checkbox-container"
      @click="toggleSavePaymentMethod"
      v-if="!isSubscription"
    >
      <div class="checkbox" :class="{ active: savePaymentMethod }">
        <img src="@/assets/images/icons/check-white.svg" alt="save payment" />
      </div>
      Save payment method
    </div> -->
    <div class="error" v-if="paymentError">{{ paymentError }}</div>
    <button class="submit-btn btn-red" @click="submit">
      <lottie
        v-if="paymentLoading"
        :options="{ animationData: authLoading }"
        :width="24"
        :height="24"
      />
      <span v-else>{{ btnCopy }}</span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Lottie from "vue-lottie"
import authLoading from "@/assets/animations/home/authLoading.json"
// import moment from "moment"
// import { ROUTER_NAMES } from "@/constants/router.constants"
import { PAYMENT_METHOD } from "@/store/payment/payment.constants"
export default {
  components: {
    Lottie,
  },
  props: {
    btnCopy: {
      type: String,
      default: "PROCEED",
    },
    redirectPath: String,
    productIds: {
      type: Array,
      require: true,
    },
    promoCodes: {
      type: Array,
      default: () => {
        return []
      },
    },
    freePurchase: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      authLoading,
      // savePaymentMethod: false,
      PAYMENT_METHOD: PAYMENT_METHOD,
    }
  },
  computed: {
    ...mapGetters("Payment", [
      "paymentError",
      "paymentLoading",
      "stripe",
      "stripePaymentElement",
      "savedPaymentMethods",
    ]),
    ...mapGetters("Store", [
      "exactRefillProduct",
    ]),
    parsedBtnCopy () {
      const copy = this.btnCopy.toLowerCase()
      return copy[0].toUpperCase() + copy.slice(1)
    },
  },
  methods: {
    ...mapActions("Payment", [
      "initStripeElements",
      "generatePaymentIntent",
      "payWithStripe",
      "generateSetupIntent",
      "setupWithStripe",
    ]),
    ...mapMutations("Payment", ["setCurrentPaymentTab"]),
    // toggleSavePaymentMethod () {
    //   this.savePaymentMethod = !this.savePaymentMethod
    // },
    async submit () {
      const confirmParams = {
        return_url: this.redirectPath,
      }
      let success
      if (this.freePurchase) {
        await this.setupWithStripe(confirmParams)
        this.setCurrentPaymentTab(PAYMENT_METHOD.STRIPE_SAVED_CARD)
        return
      } else {
        success = await this.payWithStripe(confirmParams)
      }
      if (success) {
        this.redirectHandle()
      }
    },
    redirectHandle () {
      if (this.redirectPath === window.location.href) {
        this.$emit("extraAction")
        this.$emit("stripePaymentSucceeded")
      } else {
        window.location.href = this.redirectPath
      }
    },
    initForm () {
      // Mount Stripe Elements
      if (!this.stripePaymentElement) return
      this.stripePaymentElement.mount("#payment-element")
    },
    async reloadForm () {
      this.stripePaymentElement.unmount()
      if (this.freePurchase) {
        await this.generateSetupIntent()
      } else {
        await this.generatePaymentIntent({
          productIds: this.productIds,
          promoCodes: this.promoCodes,
          exactRefillProduct: this.exactRefillProduct,
        })
      }
      await this.initStripeElements()
      this.initForm()
    },
  },
  async mounted () {
    // Generate setup intent if there is no charge
    if (this.freePurchase) {
      await this.generateSetupIntent()
    } else {
      await this.generatePaymentIntent({
        productIds: this.productIds,
        promoCodes: this.promoCodes,
        exactRefillProduct: this.exactRefillProduct,
      })
    }
    await this.initStripeElements()
    this.initForm()
  },
  watch: {
    productIds: {
      deep: true,
      async handler () {
        await this.reloadForm()
      },
    },
    promoCodes: {
      deep: true,
      async handler () {
        await this.reloadForm()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.stripe-tab {
  color: #3b3b3b;
  padding: 0 4rem;
  @include phone-small {
    padding: 0 2rem;
  }
  .back {
    position: absolute;
    top: 2rem;
    left: 2rem;
    z-index: 21;
    cursor: pointer;
  }
  .card-number-container {
    height: 4rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
  }
  .input-container {
    text-align: left;

    label {
      display: block;
      font-style: normal;
      font-weight: 600;
      font-size: 1.3rem;
      line-height: 1.6rem;
      margin: 0.9rem 0 1.3rem;
      @include phone-small {
        margin: 0.5rem 0 1rem;
      }
    }
    input,
    select {
      width: 100%;
      outline: none;
      border: 1px solid #dcdcdc;
      border-radius: 6px;
      padding: 1rem 1.1rem;
      font-style: normal;
      font-weight: normal;
      font-size: 1.6rem;
    }
    select {
      padding: 1rem 1.1rem;
      cursor: pointer;
    }
    .card-number-container {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #dcdcdc;
      display: grid;
      // padding: 1rem 1.1rem;
      grid-template-columns: 4fr 2fr 1.1fr;
      @include phone-down {
        grid-template-columns: 4fr 2fr 1.3fr;
      }
      @include phone-small {
        grid-template-columns: 4fr 2fr 1.5fr;
      }
      input {
        border: none;
      }
    }
  }
  .checkbox-container {
    margin-top: 1.8rem;
    text-align: left;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 1.6rem;
    color: #3b3b3b;
    .checkbox {
      cursor: pointer;
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 0.6rem;
      border: 0.1rem solid #e2e8ee;
      margin-right: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background: #000000;
      }
    }
  }
  .flex-container {
    display: flex;
    .input-container {
      width: 50%;
      &:first-child {
        margin-right: 1.3rem;
      }
    }
  }
  .error {
    background: rgba(250, 200, 206, 0.8);
    color: #db1d3f;
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    padding: 1rem 1.6rem;
    border-radius: 4px;
    text-align: center;
    margin: 1rem 0;
  }
  .trial-ineligibility {
    color: #545460;
    font-weight: 300;
    font-size: 1.3rem;
    background: #f3f3f3;
    margin-top: 0.5rem;
    padding: 1rem;
  }
  .submit-btn {
    box-shadow: 0px 4px 30px rgba(244, 37, 86, 0.5);
    width: 100%;
    height: 5rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    border: none;
    color: #ffffff;
    font-size: 1.8rem;
    line-height: 2.8rem;
    margin: 2rem 0 0;
    cursor: pointer;
    font-weight: bold;
    font-family: $font-poppins;
    text-transform: capitalize;
    @include tablet-down {
      margin: 2.3rem auto 0;
    }
  }
  .disclaimer {
    margin-top: 1.7rem;
    font-weight: 300;
    color: #545460;
    font-size: 1.2rem;
    text-align: left;
    a {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment/StripeTab.vue